import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const TryAndBuyIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M24 6C24 9.31371 21.3137 12 18 12C14.6863 12 12 9.31371 12 6C12 2.68629 14.6863 0 18 0C21.3137 0 24 2.68629 24 6ZM20.7947 3.17382C20.4149 2.80136 19.9634 2.50589 19.4662 2.30444C18.9689 2.10298 18.4357 1.99952 17.8973 2V6.00167L15 8.82951C16.599 10.3902 19.1957 10.3902 20.8015 8.82951C21.1821 8.458 21.4838 8.01687 21.6895 7.53139C21.8951 7.04592 22.0006 6.52562 22 6.00029C21.9994 5.47495 21.8926 4.9549 21.6858 4.46989C21.4789 3.98489 21.1761 3.54446 20.7947 3.17382ZM3.9984 7.8H11.2336C11.9191 10.3836 14.045 12.3807 16.6994 12.8794L15.4807 14.973C15.1578 15.531 14.531 15.9 13.8187 15.9H6.74314L5.69843 17.7H17.0953V19.5H5.69843C4.25483 19.5 3.34308 18.033 4.03639 16.827L5.31854 14.631L1.89948 7.8H0V6H3.10564L3.9984 7.8ZM5.69843 20.4C4.65372 20.4 3.80845 21.21 3.80845 22.2C3.80845 23.19 4.65372 24 5.69843 24C6.74314 24 7.59791 23.19 7.59791 22.2C7.59791 21.21 6.74314 20.4 5.69843 20.4ZM13.3058 22.2C13.3058 21.21 14.1511 20.4 15.1958 20.4C16.2405 20.4 17.0953 21.21 17.0953 22.2C17.0953 23.19 16.2405 24 15.1958 24C14.1511 24 13.3058 23.19 13.3058 22.2Z"
			/>
		</SvgIcon>
	);
};

export default TryAndBuyIcon;
